import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { centerFormWrap } from "../../../../utils/styles.utils";

export const FormWrap = styled.div`
  ${centerFormWrap}
`;
